import { render, staticRenderFns } from "./ClientBranchOfficesTable.vue?vue&type=template&id=8df94c1e&"
import script from "./ClientBranchOfficesTable.vue?vue&type=script&lang=js&"
export * from "./ClientBranchOfficesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports